import CustomModal from 'components/organisms/CustomModal'
import { Button } from 'react-bootstrap'
import './styles.scss'

export interface DeleteCardProps {
  show: boolean
  isNestedQuestion: boolean
  onHide: () => void
  onSubmit: () => void
}

const DeleteCardConfirmationModal = (props: DeleteCardProps): JSX.Element => {
  function onClose() {
    props.onHide()
  }

  return (
    <CustomModal
      show={props.show}
      showClose={true}
      showFooter={true}
      onHide={onClose}
      title='Confirm Delete'
      customHeaderTitleClass='delete-card-confirm-title'
    >
      <div
        className='delete-card-confirm-desc'
        data-testid='delete-card-confirm-desc'
      >
        {props.isNestedQuestion
          ? 'There might be nested data within this section that will be deleted. Are you sure you want to delete this card?'
          : 'Are you sure you want to delete this card? This action cannot be undone.'}
      </div>
      <div className='border-container' />

      <div className='button-container'>
        <Button
          onClick={props.onSubmit}
          className='submit-button delete-modal-submit-button'
          data-testid='delete-card-submit-btn'
        >
          Yes
        </Button>
        <Button
          variant='outline-secondary'
          onClick={onClose}
          className='cancel-button'
          data-testid='delete-card-cancel-btn'
        >
          No
        </Button>
      </div>
    </CustomModal>
  )
}

export default DeleteCardConfirmationModal
